module.exports = __webpack_public_path__ + "img/u242.eb47b9a3.jpg";